import ReactDOM from 'react-dom/client';
import ProjectsCarousel from './ProjectsCarousel';

window.initProjectsCarousel = (title, projects, linkToAllProjects) => {
  const root = ReactDOM.createRoot(document.getElementById('projects-carousel'));
  root.render(<ProjectsCarousel title={title} projects={projects} linkToAllProjects={linkToAllProjects} />);
}
